// =====================================================================
// PLENARIUM:CONDUCAO -- lado da TV: o que o administrador mandou mostrar
//  - useConducaoTV: le e acompanha (tempo real) a tela escolhida
//  - TelaFaseTV: tela da fase da sessao (Leitura da Ata, Expediente,
//    Uso da Tribuna...), no mesmo visual das telas de boas-vindas
// =====================================================================
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { io } from 'socket.io-client';
import { mostrarAbertura, mostrarEncerramento } from './CerimonialTV';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
const DIAS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const p2 = (n) => String(n).padStart(2, '0');
const PADRAO = { modo: 'AUTO', dados: null };

export function useConducaoTV({ sessaoId, sessao, camaraInfo }) {
  const [tela, setTela] = useState(PADRAO);
  const ctx = useRef({ sessao, camaraInfo });
  ctx.current = { sessao, camaraInfo };
  useEffect(() => {
    if (!sessaoId) { setTela(PADRAO); return undefined; }
    let vivo = true;
    const t = localStorage.getItem('token');
    const buscar = () => axios.get(`/api/conducao/sessao/${sessaoId}`, { headers: t ? { Authorization: `Bearer ${t}` } : {} })
      .then(r => { if (vivo && r.data && r.data.tela) setTela(r.data.tela); }).catch(() => {});
    buscar();
    const s = io(API);
    s.on('connect', () => { s.emit('entrar-sala', `sessao-${sessaoId}`); buscar(); });
    s.on('conducao-atualizada', (d) => {
      if (!d || d.sessaoId !== sessaoId) return;
      if (d.tela) setTela(d.tela);
      if (d.cerimonial) {
        const { sessao: se, camaraInfo: ci } = ctx.current;
        const camara = { ...(ci || {}), ...((se && se.camara) || {}) };
        if (d.cerimonial === 'abertura') mostrarAbertura({ camara, sessao: se });
        if (d.cerimonial === 'encerramento') mostrarEncerramento({ camara, sessao: se, proxima: null });
      }
    });
    return () => { vivo = false; s.disconnect(); };
  }, [sessaoId]);
  return tela;
}

const CSS = `
.pft { position: relative; width: 100vw; height: 100vh; overflow: hidden; color: #fff; font-family: 'DM Sans', 'Inter', system-ui, sans-serif;
  background: radial-gradient(ellipse 110% 85% at 50% 35%, #163a6b 0%, #0b1f3d 45%, #050c19 100%); display: flex; flex-direction: column; }
.pft-orb { position: absolute; border-radius: 50%; filter: blur(10vh); pointer-events: none; }
.pft-orb.a { width: 65vh; height: 65vh; left: -18vh; top: -20vh; background: #1d4ed8; opacity: .4; animation: pftFlutua 18s ease-in-out infinite; }
.pft-orb.b { width: 55vh; height: 55vh; right: -16vh; bottom: -18vh; background: #b8862b; opacity: .2; animation: pftFlutua 22s ease-in-out infinite reverse; }
.pft-moldura { position: absolute; inset: 3vh; border: .16vh solid rgba(245,215,142,.18); border-radius: 2.4vh; pointer-events: none; }
.pft-topo { position: relative; display: flex; align-items: center; justify-content: space-between; padding: 5.5vh 6.5vh 0; }
.pft-marca { display: flex; align-items: center; gap: 1.8vh; }
.pft-marca img { height: 7.5vh; max-width: 10vh; object-fit: contain; filter: drop-shadow(0 0 2vh rgba(245,215,142,.35)); }
.pft-marca b { display: block; font-size: 2.8vh; font-weight: 800; }
.pft-marca small { display: block; font-size: 1.5vh; letter-spacing: .5vh; text-transform: uppercase; color: #f5d78e; font-weight: 700; margin-top: .3vh; }
.pft-hora { font-size: 4.2vh; font-weight: 800; font-variant-numeric: tabular-nums; color: rgba(255,255,255,.9); text-align: right; }
.pft-hora small { display: block; font-size: 1.6vh; font-weight: 600; color: rgba(255,255,255,.55); }
.pft-centro { position: relative; flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 0 8vw; }
.pft-selo { display: inline-flex; align-items: center; gap: 1.3vh; padding: 1.1vh 2.6vh; border-radius: 99px; background: rgba(255,255,255,.07); border: .18vh solid rgba(74,222,128,.45); font-size: 1.8vh; font-weight: 800; letter-spacing: .35vh; text-transform: uppercase; color: #bbf7d0; }
.pft-selo i { width: 1.3vh; height: 1.3vh; border-radius: 50%; background: #4ade80; box-shadow: 0 0 1.4vh #4ade80; animation: pftPulso 1.6s ease-in-out infinite; }
.pft-titulo { margin-top: 3.4vh; font-size: 11vh; font-weight: 900; line-height: 1.02; letter-spacing: -.2vh;
  background: linear-gradient(90deg, #ffffff 0%, #f5d78e 50%, #ffffff 100%); background-size: 200% 100%; -webkit-background-clip: text; background-clip: text; color: transparent; animation: pftOuro 7s linear infinite, pftSobe .9s cubic-bezier(.2,.8,.2,1) both; }
.pft-linha { width: 36vh; height: .32vh; margin: 3.4vh auto 2.8vh; border-radius: 99px; background: linear-gradient(90deg, transparent, #e9c46a, transparent); }
.pft-sub { font-size: 3.6vh; font-weight: 600; color: rgba(255,255,255,.88); max-width: 80vw; animation: pftSobe .9s .2s cubic-bezier(.2,.8,.2,1) both; }
.pft-sessao { margin-top: 2.6vh; font-size: 2.2vh; font-weight: 700; letter-spacing: .15vh; text-transform: uppercase; color: rgba(219,234,254,.7); max-width: 78vw; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.pft-rodape { position: relative; display: flex; justify-content: center; gap: 2vh; padding: 0 6vh 6vh; }
.pft-num { padding: 1.4vh 3vh; border-radius: 1.6vh; background: rgba(255,255,255,.06); border: .15vh solid rgba(255,255,255,.12); text-align: center; min-width: 18vh; }
.pft-num b { display: block; font-size: 4.4vh; font-weight: 900; line-height: 1.05; }
.pft-num span { font-size: 1.6vh; font-weight: 700; letter-spacing: .25vh; text-transform: uppercase; color: rgba(255,255,255,.6); }
@keyframes pftSobe { from { opacity: 0; transform: translateY(3vh) } to { opacity: 1; transform: none } }
@keyframes pftOuro { to { background-position: -200% 0 } }
@keyframes pftPulso { 0%,100% { opacity: 1 } 50% { opacity: .35 } }
@keyframes pftFlutua { 0%,100% { transform: translate(0,0) } 50% { transform: translate(5vh,3vh) } }
`;

export function TelaFaseTV({ camara, sessao, titulo, subtitulo, presentes, total, minimo, children }) { // PLENARIUM:QUORUM_CAMARA minimo
  const [agora, setAgora] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setAgora(new Date()), 1000); return () => clearInterval(t); }, []);
  const nome = (camara && camara.nome) || 'Câmara Municipal';
  return (
    <div className="pft">
      <style>{CSS}</style>
      {children}
      <div className="pft-orb a" /><div className="pft-orb b" /><div className="pft-moldura" />
      <div className="pft-topo">
        <div className="pft-marca">
          {camara && camara.logoUrl && <img src={camara.logoUrl} alt="" />}
          <div><b>{nome}</b><small>Poder Legislativo Municipal</small></div>
        </div>
        <div className="pft-hora">{p2(agora.getHours())}:{p2(agora.getMinutes())}<small>{DIAS[agora.getDay()]}, {agora.getDate()} de {MESES[agora.getMonth()]}</small></div>
      </div>
      <div className="pft-centro">
        <div className="pft-selo"><i />Sessão em andamento</div>
        <div className="pft-titulo" key={titulo}>{titulo}</div>
        <div className="pft-linha" />
        {subtitulo && <div className="pft-sub" key={subtitulo}>{subtitulo}</div>}
        {sessao && sessao.titulo && <div className="pft-sessao">{String(sessao.titulo).replace(/\s+/g, ' ')}</div>}
      </div>
      {total > 0 && (
        <div className="pft-rodape">
          <div className="pft-num"><b>{presentes}<span style={{ fontSize: '2.4vh', letterSpacing: 0, color: 'rgba(255,255,255,.5)' }}> / {total}</span></b><span>Presentes</span></div>
          <div className="pft-num"><b style={{ color: presentes >= (minimo || Math.floor(total / 2) + 1) ? '#4ade80' : '#f87171', fontSize: '3.4vh', padding: '.5vh 0' }}>{presentes >= (minimo || Math.floor(total / 2) + 1) ? 'ATINGIDO' : 'INSUFICIENTE'}</b><span>Quórum</span></div>
        </div>
      )}
    </div>
  );
}
